export default "/img/FR.50b890f04cad7a20759575adcfa28d78.png";